import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction:column;
  cursor:default;

  span{
    margin-top:1rem;
    display:flex;
    text-align: center;
  }

  .close{
    display:flex;
    width: 100%;
    height:2rem;
    margin-top:2rem;
    justify-content:center;
    align-items:center;
    text-align: center;
    border-top: 1px solid;
    cursor:pointer;
    user-select: none;
    border-radius: 4px;
    background-color:#ffffff61;

  }
`
